module.exports = __webpack_public_path__ + "img/C04TechSparabara4_ua.7c93b6b5.webp";